<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import VoxCarousel from './VoxCarousel.vue'

const slides = [
  {
    title: "The Future of Betting is <mark>Voice</mark>",
    subtitle: "We have been understanding bets that have been typed and sent as a message for over 10 years.",
    image: new URL('../assets/images/hero/home-1.webp', import.meta.url).href
  },
  {
    title: "Place Bets by <mark>Speaking</mark>",
    subtitle: "Allow customers to populate the bet slip simply by speaking their bet.",
    image: new URL('../assets/images/hero/home-2.webp', import.meta.url).href
  },
  {
    title: "Frictionless <mark>Acquisition</mark>",
    subtitle: "Put the fun before the friction. Allow customers to place their free bet first.",
    image: new URL('../assets/images/hero/home-3.webp', import.meta.url).href
  }
]

const parallaxX = ref(0)

const handleScroll = () => {
  // Multiply scrollY by a factor to control parallax speed
  parallaxX.value = window.scrollY * 0.5
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
  <div class="hero-carousel-wrapper">
    <VoxCarousel :items="slides" autoplay pagination>

      <template #default="{ item }">
        <div 
          class="hero-slide" 
          :style="{ backgroundImage: `url(${item.image})` }"
        >
          <div class="container hero-content">
            <h1 v-html="item.title" class="gradient-text"></h1>
            <p v-html="item.subtitle" class="lead"></p>
            <div class="hero-actions">
              <RouterLink to="/solutions" class="btn btn-primary">View Solutions</RouterLink>
            </div>
          </div>
        </div>
      </template>
    </VoxCarousel>

    <!-- Parallax Waves (Grayscale & Offset) -->
    <div class="hero-waves">
      <div 
        class="parallax-wave wave-1" 
        :style="{ backgroundPositionX: `-${parallaxX}px` }"
      ></div>
      <div 
        class="parallax-wave wave-2" 
        :style="{ backgroundPositionX: `calc(-${parallaxX * 1.15}px + 50px)` }"
      ></div>
    </div>
  </div>
</template>

<style scoped>
.hero-carousel-wrapper {
  position: relative;
}

.hero-waves {
  position: absolute;
  bottom: clamp(30px, 6vh, 60px);
  left: 0;
  width: 100%;
  height: clamp(100px, 20vh, 220px);
  z-index: 2;
  pointer-events: none;
  overflow: hidden;
}

.parallax-wave {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('../assets/logo/voxbet-wave-loop-grayscale.svg');
  background-repeat: repeat-x;
  background-position: center center;
  opacity: 0.6;
}

.wave-1 {
  background-size: auto 68%;
  z-index: 2;
  filter: blur(0.5px);
}

.wave-2 {
  background-size: auto 83%;
  background-position: center calc(50% - 15px);
  opacity: 0.3;
  z-index: 1;
  filter: blur(2.5px);
}

.hero-content {
  position: relative;
  z-index: 5;
}

@media (max-width: 992px) {
  .hero-waves {
    height: clamp(80px, 15vh, 160px);
    bottom: clamp(15px, 4vh, 45px);
  }
  .wave-2 {
    background-position: center calc(50% - 10px);
  }
}

@media (max-width: 576px) {
  .hero-waves {
    height: 90px;
    bottom: 25px;
  }
  .wave-1 {
    background-size: auto 65%;
  }
  .wave-2 {
    background-size: auto 80%;
    background-position: center calc(50% - 5px);
  }
}
</style>
